// src/components/Logo.jsx
import React from "react";
import { Box } from "@mui/material";
import logo from "../assets/logo/kw-logo-conletrablanca.png";

export default function Logo({ size = 164, ...rest }) {
  return (
    <Box
      component="img"
      src={logo}
      alt="KW-Solar Logo"
      sx={{ width: size, height: "auto" }}
      {...rest}
    />
  );
}
